module.exports = __webpack_public_path__ + "img/rock-huge-15.7c56ce20.png";